export const PurchaseOrderValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.formData.FK_Supplier_ID || formData.formData.FK_Supplier_ID==="0") {
        errors.FK_Supplier_ID = 'This field is required';
    }

    if (!formData.formData.FK_SupplierContact_ID || formData.formData.FK_SupplierContact_ID==="0") {
        errors.FK_SupplierContact_ID = 'This field is required';
    }
   
    
   
   
    return errors;
};
